import React from 'react';
import { Notification, Typography } from '@telus-uds/components-web';
import { Wrapper } from './css';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

const PasswordMessage = () => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    USERS: {
      USER_AUTHENTICATION: {
        labels: {
          PASWORD_MESSAGE_8_CHARECTER,
          MIX_NUMBER_LETTERS,
          SEQUENTIAL_REPEAT,
          NO_SPACE_AND_SPECIAL_CHAR,
          PASSWORD_GENERAL_MESSAGE
        }
      }
    }
  } = localizedStrings;
  return (
    <Wrapper>
      <Notification copy="en">
        <Typography>
          <b>{PASSWORD_GENERAL_MESSAGE}</b>:
          <ul className="password-field">
            <li>{PASWORD_MESSAGE_8_CHARECTER}</li>
            <li> {MIX_NUMBER_LETTERS}</li>
            <li>{SEQUENTIAL_REPEAT}</li>
            <li>{NO_SPACE_AND_SPECIAL_CHAR}</li>
          </ul>
        </Typography>
      </Notification>
    </Wrapper>
  );
};

export default PasswordMessage;
